import { useEffect, type EffectCallback } from "react";

/**
 * マウント時に一度だけ実行する。戻り値の cleanup はアンマウント時に呼ばれる。
 * `useEffect(fn, [])` の置き換え。
 */
export const useMount = (effect: EffectCallback): void => {
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(effect, []);
};
